
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import CommonTab from '@/components/common/CommonTab.vue';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import CommonDropMenu from '@/components/common/CommonDropMenu.vue';
import CommonTableHead from '@/components/common/CommonTableHead.vue';
import ReportCard from './ReportCard.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import AllScreen from './AllScreen.vue';
import { dropMenuProject } from '@/types/dropMenu';
import { hotDropMenu, STAT, AJAX_STATUS } from '@/config/config';
import { homeAllOnsd, homeAllOffsd, homeAllOfftb, homeAllOntb } from '@/config/stat';
import { getHomeReportList, getReadNum } from '@/apis/index';
import { getClientHeight, formateHkStockcode } from '@/utils/tools';

@Component({
  components: {
    CommonTab,
    CommonBlockLine,
    CommonDropMenu,
    CommonLoading,
    CommonTableHead,
    AllScreen,
    ReportCard,
  },
})
export default class SingleRank extends Vue {
  // 页面滚动位置
  @Prop() private scrollTop!: number;
  // 活动tab的索引 监听变化数据获取
  @Prop() private activeTabIndex!: number;
  @Prop() private slide!: number;
  // 选择器选择的信息
  @Prop() private selectInfo!: any;
  // 下拉菜单信息
  dropMenu = hotDropMenu;
  // 是否展示深度研报
  isDeep = false;
  // 是否展示图表
  isShowChart = true;
  // 选择的周期
  period = '';
  // 数组列表
  list = [];
  // 是否已经激活获取过接口数据
  isActived = false;
  // 全部的选择信息
  queryInfo = {};
  // 页面的总的高度
  totalHeight = 0;
  // 列表的整体
  clientHeight = 0;
  // 获取视窗高度
  viewHeight = 0;
  // 接口请求的状态
  ajaxStatus = AJAX_STATUS.loading;
  // 是否在接口请求
  isAjaxing = false;
  // 页面埋点信息
  stat = STAT.homeAll;
  // 监听选择信息变化
  @Watch('selectInfo', { immediate: false, deep: true })
  onInfoChange(newValue: any) {
    const { isDeep, isShowChart, queryInfo, period } = newValue;
    if (isShowChart !== this.isShowChart) {
      // 是否展示图表发送埋点
      this.isShowChart ? homeAllOfftb() : homeAllOntb();
      this.isShowChart = isShowChart;
      // 不再请求接口只变更页面的高度
      this.changeHeight();
      return;
    }
    if (this.isDeep !== isDeep) {
      // 是否为深度分析
      this.isDeep ? homeAllOffsd() : homeAllOnsd();
    }
    // 深度分析变更
    this.isDeep = isDeep;
    // 接口请求的参数
    this.queryInfo = queryInfo;
    // 周期
    this.period = period;
    // 获取数据
    this.getData();
    window.scrollTo(0, 0);
  }
  @Watch('scrollTop')
  onScrollTopChanged(newValue) {
    // 监听滚动按需加载
    if (newValue + this.viewHeight >= this.totalHeight && this.activeTabIndex === 3 + this.slide) {
      this.getData(true);
    }
  }
  @Watch('activeTabIndex')
  onActiveTabIndexChanged(newValue) {
    if (newValue === 3 + this.slide) {
      if (!this.isActived) {
        // 获取视窗高度
        this.viewHeight = getClientHeight();
        this.getData();
      }
      this.isActived = true;
    }
  }
  followOrg(id: string, status: boolean, type: 'orgId' | 'authorId') {
    if (type === 'orgId') {
      // 关注的是机构
      this.$set(this.$followOrgList, id, status ? 2 : 1);
    } else {
      // 关注的是分析师
      this.$set(this.$followAuthorList, id, status ? 2 : 1);
    }
  }
  changeInfo(info: dropMenuProject) {
    // 处理选中的时间
    this.period = info.value;
    this.getData();
  }
  changeHeight() {
    this.$nextTick(() => {
      // 更新高度状态
      const dom = this.$refs.allReport as HTMLElement;
      this.clientHeight = dom.clientHeight;
      this.totalHeight = dom.parentElement.clientHeight;
    });
  }
  handleReadNum(tempArr: Array<string>, res: any, flag: boolean) {
    const { end, nodata, nomore } = AJAX_STATUS;
    // 优化获取阅读数
    getReadNum({
      field: 'clicks',
      key: tempArr.join(','),
    })
      .then(num => {
        const list = res.data.list.map(item => ({
          ...item,
          readNum: num.result[`seq_${item.pid}`],
        }));
        // 整合阅读数
        this.list = flag ? this.list.concat(list) : list;
        this.changeHeight();
      })
      .catch(() => {
        this.ajaxStatus = end;
        const list = res.data.list.map(item => ({
          ...item,
          readNum: 0,
        }));
        this.list = flag ? this.list.concat(list) : list;
      })
      .finally(() => {
        this.isAjaxing = false;
        const len = this.list.length;
        if (!len) {
          this.ajaxStatus = nodata;
        } else {
          this.ajaxStatus = len < 15 ? nomore : end;
        }
      });
  }
  getData(flag: boolean = false) {
    const { nomore, loading } = AJAX_STATUS;
    if (this.isAjaxing || (this.ajaxStatus === nomore && flag)) {
      return;
    }
    if (!flag) {
      this.list = [];
    }
    this.ajaxStatus = loading;
    this.isAjaxing = true;
    const len = this.list.length;
    let form = {
      is_deep: this.isDeep ? 1 : '',
      period: this.period,
      seq: len ? this.list[len - 1].seq : '',
      cat: '',
      industry_id: '',
      author_id: '',
      org_id: '',
      rating: '',
    };
    form = Object.assign(form, this.queryInfo);
    for (const key in form) {
      if (Object.prototype.hasOwnProperty.call(form, key)) {
        const element = form[key];
        if (!element) {
          delete form[key];
        }
      }
    }
    this.getReport(form, flag);
  }
  handleData(res) {
    const tempArr = [];
    res.data.list.forEach(item => {
      tempArr.push(`seq_${item.pid}`);
      if (item.authorId) {
        this.$set(
          this.$followAuthorList,
          item.authorId,
          this.$followAuthorList.hasOwnProperty(item.authorId) ? this.$followAuthorList[item.authorId] : 1
        );
      } else {
        this.$set(
          this.$followOrgList,
          item.orgId,
          this.$followOrgList.hasOwnProperty(item.orgId) ? this.$followOrgList[item.orgId] : 1
        );
      }
      item.stockCode = formateHkStockcode(item.stockCode, item.market);
    });
    return tempArr;
  }
  getReport(form, flag) {
    const { nomore, nodata } = AJAX_STATUS;
    // 获取研报数据
    getHomeReportList(form)
      .then(res => {
        if (res.statusCode === 0) {
          if (res.data.list && res.data.list.length) {
            // 获取阅读数接口的key整合
            const tempArr = this.handleData(res);
            this.handleReadNum(tempArr, res, flag);
          } else {
            this.ajaxStatus = this.list.length ? nomore : nodata;
            this.isAjaxing = false;
          }
        } else {
          this.ajaxStatus = nodata;
        }
      })
      .catch(() => {
        this.ajaxStatus = nodata;
      });
  }
}
